import { useTranslations } from "@jugl-web/utils";
import { FC } from "react";

export const WidgetEmptyStateLabel: FC = () => {
  const { t } = useTranslations();

  return (
    <span className="text-sm text-[#707577]">
      {t({
        id: "cx-page.no-sessions-yet",
        defaultMessage: "No sessions yet ℹ️",
      })}
    </span>
  );
};
